module.exports = __webpack_public_path__ + "img/four3Blue.8275612d.jpg";